import { type FC } from 'react';
import { Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconArrowRight, type Icon } from '@tabler/icons-react';
import { type CreateOrderPaymentMethod } from '../../../actions';
import styles from './Action.module.css';

export interface ActionItem {
    method: CreateOrderPaymentMethod;
    title: string;
    description: string;
    icon: Icon;
}

interface ActionProps extends ActionItem {
    onCreate: (paymentMethod: CreateOrderPaymentMethod) => void;
}

export const Action: FC<ActionProps> = ({ method, onCreate, title, description, icon: Icon }) => {
    return (
        <UnstyledButton
            className={styles.action}
            data-method={method}
            aria-label={title}
            onClick={() => {
                onCreate(method);
            }}
        >
            <Group
                wrap='nowrap'
                gap='md'
                align='center'
                className={styles.content}
            >
                <Icon
                    className={styles.icon}
                    size={28}
                    stroke={1.6}
                />

                <Stack
                    gap={2}
                    flex={1}
                >
                    <Text
                        size='lg'
                        fw={700}
                        lh={1.2}
                    >
                        {title}
                    </Text>

                    <Text
                        size='sm'
                        c='dimmed'
                        lh={1.3}
                    >
                        {description}
                    </Text>
                </Stack>

                <IconArrowRight
                    className={styles.arrow}
                    size={24}
                    stroke={1.7}
                />
            </Group>
        </UnstyledButton>
    );
};
